import { Injectable } from '@angular/core';

import { AuthService } from "../../../../shared/services/auth.service";
import { despachosRoute } from "../../../shared/data.service";
import {newRoute, editRoute, configuracaoRoute} from "../../../../shared/services/data.service";
import { obrigacoesRoute } from "../../shared/data.service";
import { obrigacaoTiposRoute } from "./data.service";

@Injectable()
export class ObrigacaoTipoNavigationService {

  constructor(
    private _authService: AuthService
  ) { }

  goToList() {
    var router: string = despachosRoute + '/' + obrigacoesRoute + '/' + configuracaoRoute + '/' + obrigacaoTiposRoute;
    this._authService.navigateTo(router);
  }

  goToNew() {
    var router: string = despachosRoute + '/' + obrigacoesRoute + '/' + configuracaoRoute + '/' + obrigacaoTiposRoute + '/' + newRoute;
    this._authService.navigateTo(router);
  }

  goToEdit(objectId: number) {
    var router: string = despachosRoute + '/' + obrigacoesRoute + '/' + configuracaoRoute + '/' + obrigacaoTiposRoute + '/' + editRoute;
    this._authService.navigateTo(router, objectId);
  }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/despachos/obrigacoes/obrigacao-tipos/shared/obrigacao-tipo-navigation.service.ts
 **/